"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react"); // Generated by CoffeeScript 2.3.2


var addEffect;

addEffect = function addEffect(callback, changeProps) {
  return function (props) {
    var changeProp;
    (0, _react.useEffect)(callback(props), function () {
      var i, len, results; // TODO: throw nice error if changeProps isn't array/iterable or any changeProp isn't a string?

      if (changeProps != null) {
        results = [];

        for (i = 0, len = changeProps.length; i < len; i++) {
          changeProp = changeProps[i];
          results.push(props[changeProp]);
        }

        return results;
      }
    }());
    return props;
  };
};

var _default = addEffect;
exports["default"] = _default;